import type { Store } from '@warp-drive/core';

import { updatePartnershipMessageReadReceipt } from '../../data/builders/coaching/partnership-messages.ts';
import {
  incomingUnreadMessages,
  type MessagingRole,
  type PartnershipConversation,
} from './partnership-messages.ts';

export async function markPartnershipConversationRead(
  conversation: PartnershipConversation,
  role: MessagingRole,
  currentUserId: string,
  store: Store
): Promise<void> {
  const readAt = new Date().toISOString();
  const field = role === 'coach' ? 'readByCoachAt' : 'readByCoacheeAt';

  for (const message of incomingUnreadMessages(
    conversation,
    role,
    currentUserId
  )) {
    message[field] = readAt;

    try {
      await store.request(
        updatePartnershipMessageReadReceipt(message, field, store)
      );
    } catch (error) {
      // A receipt is not worth failing the transition into the thread over.
      message[field] = null;
      console.error(error);
    }
  }
}
